import { FigmaNodeReference } from "@supernova-studio/model";
import { z } from "zod";
import { DTOFigmaNodeOrigin, DTOFigmaNodeRenderFormat } from "./figma-node";

export const DTOFigmaNodeData = z.object({
  // Id of the node in the Figma file
  figmaNodeId: z.string(),

  // Validity
  isValid: z.boolean(),

  // Asset data
  assetId: z.string(),
  assetUrl: z.string(),
  assetFormat: DTOFigmaNodeRenderFormat,

  // Asset metadata
  assetScale: z.number(),
  assetWidth: z.number().optional(),
  assetHeight: z.number().optional(),
});

export const DTOFigmaNode = FigmaNodeReference.omit({
  data: true,
  origin: true,
}).extend({
  data: DTOFigmaNodeData,
  origin: DTOFigmaNodeOrigin,
});

export type DTOFigmaNodeData = z.infer<typeof DTOFigmaNodeData>;
export type DTOFigmaNode = z.infer<typeof DTOFigmaNode>;
